import { useEffect, useState } from "react";
import { countdownState } from "@/lib/media";
import { cn } from "@/lib/utils";

/** Live pill: «om 3 dagar 4 t» → «I dag kl. 20:00» → «Pågår no» → «Avslutta». Ticks every 30 s. */
export const EventCountdown = ({ ev, className, tone = "dark" }) => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 30_000); return () => clearInterval(t); }, []);
  const c = countdownState(ev, now);
  if (!c.label) return null;
  const light = tone === "light";
  const toneCls = light
    ? (c.state === "live" ? "border-sol/70 bg-background text-foreground" : c.state === "over" ? "border-border bg-background text-muted-foreground" : "border-border bg-background text-foreground")
    : (c.state === "live" ? "border-sol/70 bg-ink/45 text-sol" : c.state === "over" ? "border-paper/25 bg-ink/45 text-paper/60" : "border-paper/30 bg-ink/45 text-paper");
  return (
    <span className={cn("inline-flex h-9 items-center gap-2 rounded-full border px-3.5 text-[12.5px] font-medium tabular backdrop-blur-md", toneCls, className)} data-testid="event-countdown" data-state={c.state}>
      <span className={cn("h-1.5 w-1.5 rounded-full", c.state === "over" ? (light ? "bg-muted-foreground/50" : "bg-paper/40") : "bg-sol", c.state === "live" && "animate-pulse")} aria-hidden="true" />
      {c.label}
      {c.detail && <span className={light ? "text-muted-foreground" : "text-paper/65"}>· {c.detail}</span>}
    </span>
  );
};
